import { HttpClient } from "./HttpClient";
export * from "./HttpClient";
export * from "./getQueryClient";

export const apiHttpClient = new HttpClient("/api", {
	throwOnError: true,
});

export const aiHttpClient = new HttpClient(
	// biome-ignore lint/style/noNonNullAssertion: Want to throw an error if this env var is not set, as the app won't work without it
	process.env.NEXT_PUBLIC_AI_PROXY_API_URL!,
	{
		timeout: 60_000,
		throwOnError: true,
	}
);

export const resHttpClient = new HttpClient(
	// biome-ignore lint/style/noNonNullAssertion: Want to throw an error if this env var is not set, as the app won't work without it
	process.env.NEXT_PUBLIC_RESOURCES_PROXY_API_URL!,
	{
		timeout: 15_000,
	}
);
